<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'dialogDetailCharacter',
})
</script>
<template>
  <ant-modal v-model:open="state.dialog.visible" :centered="true" :wrap-class-name="'wrap-character-dialogDetail'"
    :title="state.dialog.title" :width="state.dialog.width" :ok-text="state.dialog.submitTxt"
    :cancel-button-props="{ style: { display: 'none' } }" @ok="closeDialog" @cancel="closeDialog" :closable="false"
    :maskClosable="false">
    <div class="px-[36px] py-[20px]">
      <a-form :model="state.ruleForm" :wrapper-col="{ style: 'flex: 1' }">
        <a-form-item label="角色名称">
          <a-input v-model:value="state.ruleForm.name" disabled />
        </a-form-item>
        <a-form-item label="用户列表">
          <div class="detail-area">
            <a-table :columns="columns" :data-source="pageList" :pagination="false" size="small" />
          </div>
          <ant-pagination v-model:current="state.tableData.pageNum" v-model:page-size="state.tableData.pageSize"
            :total="state.tableData.total" :page-size-options="['10', '20']" :show-size-changer="false"
            :show-total="(total) => `共 ${total} 条`" :showQuickJumper="true" @change="onPageChange"
            @show-size-change="onShowSizeChange" />
        </a-form-item>
      </a-form>
    </div>
  </ant-modal>
</template>

<script setup lang="ts" name="dialogDetailCharacter">
import { reactive, computed } from 'vue'

const state = reactive({
  dialog: {
    visible: false,
    title: '',
    submitTxt: '关闭',
    width: '645px'
  },
  ruleForm: {
    name: '',
    area: [] as any[]
  },
  tableData: {
    pageNum: 1,
    pageSize: 5,
    total: 0
  }
})

const pageList = computed(() => {
  const { pageNum, pageSize } = state.tableData
  const start = (pageNum - 1) * pageSize
  const end = pageNum * pageSize
  return state.ruleForm.area.slice(start, end)
})

const columns = [
  { title: '用户ID', dataIndex: 'userId', key: 'userId', ellipsis: true, align: 'center' },
  { title: '昵称', dataIndex: 'userName', key: 'userName', ellipsis: true, align: 'center' },
  { title: '手机号', dataIndex: 'tel', key: 'tel', ellipsis: true, align: 'center' }
]

const openDialog = (res: any, name: string) => {
  state.ruleForm.name = name
  state.ruleForm.area = res || []
  state.tableData.pageNum = 1
  state.tableData.pageSize = 5
  state.tableData.total = state.ruleForm.area.length
  state.dialog.title = '查看人员'
  state.dialog.submitTxt = '关闭'
  state.dialog.visible = true
}

const onPageChange = (page: number, pageSize: number) => {
  state.tableData.pageNum = page
  state.tableData.pageSize = pageSize
}

const onShowSizeChange = (current: number, size: number) => {
  state.tableData.pageNum = current
  state.tableData.pageSize = size
}

const closeDialog = () => {
  state.dialog.visible = false
}

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
// ===== 表单 =====
:deep(.ant-form-item) {
  margin-bottom: 0;
  padding-bottom: 16px;
}

:deep(.ant-form-item-label) {
  margin-left: 0;
  margin-right: 5px;
  width: 80px;
  text-align: right;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  height: 40px;
}

:deep(.ant-form-item-label > label) {
  font-size: 14px;
  line-height: 1;
  font-weight: 400;
}

:deep(.ant-input-affix-wrapper) {
  height: 40px;
  padding: 0 11px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

:deep(.ant-input-disabled) {
  height: 40px;
  border-color: #C5C5D3;
  border-radius: 4px;
}

:deep(.ant-select-selector) {
  height: 40px !important;
  display: flex;
  align-items: center;
  border-radius: 4px;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-input-affix-wrapper:not(:hover):not(.ant-input-affix-wrapper-focused)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-select:not(.ant-select-disabled):not(.ant-select-focused) .ant-select-selector:not(:hover)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(textarea.ant-input:not(:hover):not(:focus)) {
  border-color: #C5C5D3;
}

.detail-area {
  width: 100%;
  border: 1px solid #C5C5D3;
  border-radius: 4px;
  overflow: hidden;

  :deep(.ant-table) {
    font-size: 14px;
    font-weight: 400 !important;
  }

  :deep(.ant-table-thead > tr > th) {
    background: #F1F1F1;
    font-weight: 400;
  }

  :deep(.ant-table-tbody > tr) {
    background: #FFFFFF;
  }
}
</style>
